// Recuperação de "stale chunk" pós-deploy.
//
// O admin é um SPA com rotas em lazy import (`() => import(...)`). Cada deploy
// gera assets com hash novo e remove os antigos. Uma aba já aberta continua
// referenciando os chunks antigos; ao navegar (clicar num item de menu) o
// import dinâmico busca um arquivo que não existe mais → falha silenciosa e o
// menu "trava". Um F5 baixa o index.html novo (servido com no-store) e resolve.
//
// Aqui detectamos essa falha e recarregamos automaticamente na rota pretendida
// — o F5 que o usuário fazia na mão.

// isChunkLoadError reconhece as mensagens de falha de import dinâmico nos
// diferentes browsers/bundlers.
export function isChunkLoadError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : typeof err === "string" ? err : "";
  return /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|chunkloaderror|loading chunk \d+ failed/i.test(
    msg,
  );
}

const RELOAD_FLAG = "lk:chunkReloaded";

// markChunkReload marca que um reload por chunk stale está em andamento e
// retorna true se DEVE recarregar agora. Retorna false se já houve um reload
// não seguido de navegação bem-sucedida — evita loop quando o reload não
// resolve (ex.: quebra real, não staleness). clearChunkReload (chamado num
// afterEach bem-sucedido) rearma para um futuro deploy.
export function markChunkReload(): boolean {
  try {
    if (sessionStorage.getItem(RELOAD_FLAG) === "1") return false;
    sessionStorage.setItem(RELOAD_FLAG, "1");
  } catch {
    // sessionStorage indisponível (modo privado etc.) — sem guarda, mas o
    // reload ainda é melhor que o menu travado; segue.
  }
  return true;
}

export function clearChunkReload(): void {
  try {
    sessionStorage.removeItem(RELOAD_FLAG);
  } catch {
    /* noop */
  }
}
